module.exports = __webpack_public_path__ + "static/media/cazino_zeppelin.yggdrasil.35329949.jpeg";